import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Translate from '@hydra/common/components/i18n';
import Image from '@hydra/common/components/Image';

import Criterium from '@hydra/common/criterium/Criterium';

const useStyles = makeStyles(theme => ({
  image: {
    marginRight: theme.spacing(1),
    height: '16px',
    width: '16px'
  }
}));

export const Favicon = ({ criterium }) => {
  const classes = useStyles();
  const { data, url } = criterium;

  const faviconExist = data.length > 0;

  const textKey = faviconExist ? 'favicon_ok' : 'favicon_ko';
  const src = `https://www.google.com/s2/favicons?sz=32&domain=${url}`;

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {faviconExist ? <Image src={src} className={classes.image} /> : null}
      <Translate content={textKey} />
    </Criterium>
  );
};

Favicon.propTypes = {
  criterium: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.array
  })
};

export default React.memo(Favicon);
